import VueLoader from '../../default/vue-loader'
import Confirmation from './confirmation'

document.addEventListener('turbolinks:load', () => {
  VueLoader.loadVueComponent(Confirmation, document.getElementById('OrderItemNoTable'))
})
